import React from "react";
import { Box, Card, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AccessibilityNewRoundedIcon from "@mui/icons-material/AccessibilityNewRounded";
import CodeRoundedIcon from "@mui/icons-material/CodeRounded";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import { IconTile } from "../../components/ui";
import { CheckList, FeatureCard, PageHero, Section } from "./MarketingParts";

export default function MarketingStandard() {
  const { t } = useTranslation();

  return (
    <>
      <PageHero eyebrow={t("mk_standard_eyebrow")} icon={<GavelOutlinedIcon sx={{ fontSize: 16 }} aria-hidden="true" />} title={t("m_standard_title")} subtitle={t("m_standard_subtitle")} />

      <Section sx={{ pt: { xs: 5, md: 7 } }}>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: { xs: 2.5, md: 3 } }}>
          <FeatureCard>
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2.5 }}>
              <IconTile size={44}>
                <AccessibilityNewRoundedIcon />
              </IconTile>
              <Typography variant="h2" sx={{ fontSize: "1.25rem" }}>
                {t("m_standard_widget_does_title")}
              </Typography>
            </Stack>
            <CheckList items={[t("m_standard_widget_does_1"), t("m_standard_widget_does_2"), t("m_standard_widget_does_3")]} />
          </FeatureCard>

          <FeatureCard>
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2.5 }}>
              <IconTile size={44} tone="warning">
                <CodeRoundedIcon />
              </IconTile>
              <Typography variant="h2" sx={{ fontSize: "1.25rem" }}>
                {t("m_standard_site_needs_title")}
              </Typography>
            </Stack>
            <CheckList tone="warning" items={[t("m_standard_site_needs_1"), t("m_standard_site_needs_2"), t("m_standard_site_needs_3")]} />
          </FeatureCard>
        </Box>

        <Card
          sx={{
            mt: { xs: 2.5, md: 3 },
            p: { xs: 3, md: 4 },
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2.5,
            bgcolor: (th) => th.aw.softer,
            boxShadow: "none",
          }}
        >
          <IconTile size={48} tone="violet">
            <AutoAwesomeOutlinedIcon />
          </IconTile>
          <Box>
            <Typography variant="h2" sx={{ fontSize: "1.25rem", mb: 1 }}>
              {t("m_standard_ai_audit_title")}
            </Typography>
            <Typography sx={{ color: "text.secondary", lineHeight: 1.75 }}>{t("m_standard_ai_audit_desc")}</Typography>
          </Box>
        </Card>
      </Section>
    </>
  );
}
